import AmericanExpressLogo from "../../../../assets/images/bank-logo-amex.png";
import { ReactComponent as MastercardLogo } from "../../../../assets/images/bank-logo-mastercard.svg";
import { ReactComponent as VisaLogo } from "../../../../assets/images/bank-logo-visa.svg";
import { ReactComponent as UnknownLogo } from "../../../../assets/images/bank-logo-unknown.svg";

type CreditCardBrandIconProps = {
    brand: "amex" | "mastercard" | "visa" | string;
    styles: { height: number | string };
};
export function CreditCardBrandIcon({
    brand,
    styles,
}: CreditCardBrandIconProps): JSX.Element {
    switch (brand.toLowerCase()) {
        case "amex":
            return (
                <div style={{ ...styles }}>
                    <img
                        style={{
                            maxHeight: "100%",
                            maxWidth: "100%",
                            objectFit: "contain",
                            objectPosition: "center",
                        }}
                        src={AmericanExpressLogo}
                    />
                </div>
            );
        case "mastercard":
            return <MastercardLogo {...styles} />;
        case "visa":
            return <VisaLogo {...styles} />;
        default:
            return <UnknownLogo {...styles} />;
    }
}
